<isp-login-form
  [doc]="loginDoc$ | async"
  [socialData]="socialData$ | async"
  [registerData]="registerData$ | async"
  [documentsData]="documentsData$ | async"
  [copyrightData]="copyrightData$ | async"
  [templateConfigs]="templateConfigs"
  (buttonClick)="onButtonClick($event)"
  (changeModel)="onChangeModel($event)"
></isp-login-form>
<isp-svg-sprite></isp-svg-sprite>
